/* eslint-disable react/prop-types */
import { memo, useState, useEffect } from "react";
import PropertyCard from "@/components/home/HomeProperties/PropertyCard";
import { trackButtonClick } from "@/utils/analytics";
import { getRecommendedPropertyWatchList } from "@/api/home";
import "../../srp/CardComponents/SRPCard.css";
import viewMoreIcon from '../../../../public/assets/images/pdp/viewMore.png';
import "./commercial-recommended.css";

const CommercialRecommendedProperties = ({ nearbyProperties, state, propertyId }) => {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const initProperties = async () => {
      if (!nearbyProperties || nearbyProperties.length === 0) return;

      const mapped = nearbyProperties.map((card) => ({
        ...card,
        propAddress: {
          streetNumber: card?.streetNumber,
          streetName: card?.streetName,
          city: card?.city,
          state: card?.state,
          zip: card?.zip,
        },
        currentBid: card?.currentBid?.replace("$", "") || undefined,
        imageUrl: card?.defaultImageLocation,
      }));

      try {
        const propertyIds = mapped.map((p) => p?.propertyId).join(",");
        const watchListResponse = await getRecommendedPropertyWatchList([propertyIds]);
        const watchlistedIds = new Set(watchListResponse);
        const updatedProperties = mapped.map((prop) => ({
          ...prop,
          onWatchList: watchlistedIds.has(prop.propertyId) ? "Y" : "N",
        }));
        setProperties(updatedProperties);
      } catch {
        setProperties(mapped);
      }
    };

    initProperties();
  }, [nearbyProperties]);

  const viewMoreHref = `/near-by?category=commercial${state ? `&state=${state}` : ""}`;

  const handleViewMoreClick = () => {
    trackButtonClick({
      eventName: "recommended_props_view_more_click",
      eventCategory: "NEW-PDP",
      eventSource: "on view more recommended properties click",
      eventLabel: `Property ID: ${propertyId} | Rank:1`,
    });
  };

  return (
    <div className="commercial-recommended">
      <div className="commercial-recommended__header">
        <h2 className="commercial-recommended__title">Recommended Commercial Properties</h2>
        <a
          className="commercial-recommended__view-more-link"
          href={viewMoreHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleViewMoreClick}
        >
          View More Properties <img src={viewMoreIcon} alt="" style={{ width: 16, height: 16, marginLeft: 4 }} aria-hidden="true" />
        </a>
      </div>

      <div className="commercial-recommended__grid">
        {properties.slice(0, 5).map((item, index) => (
          <PropertyCard
            key={item.propertyId || index}
            item={item}
            cardIndex={index}
            properties={properties}
            setProperties={setProperties}
            tabName="Recommended-Commercial"
          />
        ))}
      </div>
    </div>
  );
};

export default memo(CommercialRecommendedProperties);
